import React from 'react';
import ReactDOM from 'react-dom';

const portalRoot = document.getElementById('portal');

class Portal extends React.Component {
	constructor() {
		super();
		this.elelement = document.createElement('div');
	}

	componentDidMount() {
		portalRoot.appendChild(this.elelement);
	}

	componentWillUnmount() {
		portalRoot.removeChild(this.elelement);
	}

	render() {
		const { children } = this.props;
		return ReactDOM.createPortal(children, this.elelement);
	}
}

export default Portal;
